module.exports = __webpack_public_path__ + "static/media/Trybetunes.94f5b1fd.mp4";